<template>
  <v-dialog v-model='dialog'>
    <template v-slot:activator="{ on }">
      <v-btn style='margin: 2px' color='primary' v-on='on' ref='activatorButton'>
        NOM 151<v-icon>mdi-certificate-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>{{ dialogTitle }}</v-card-title>
      <v-card-text>
        <v-data-table
          v-model='selected'
          :headers='headers'
          :items='constancias'
          single-select
          show-select
          @click:row='rowSelected'
          :options.sync='options'
          :server-items-length='total'
          :footer-props='{
            itemsPerPageOptions: [5, 10, 20, 50]
          }'
          :no-data-text='noDataText'
        >
          <template v-slot:top>
            <slotbar fluid :visible='dialog' :slots='2' :slotWidth='500'>
              <template v-slot:slot1>
                <v-btn v-if='doc.length > 0' style='margin: 2px;' color='primary' @click='changeMode'>{{ modeBtnText }}</v-btn>
              </template>
              <template v-slot:slot2>
                <v-btn :disabled='selected.length === 0' style='margin: 2px;' color='primary' @click='$emit("verContratoEvent", selected[0].document)'>Ver Contrato</v-btn>
                <v-btn :disabled='selected.length === 0' style='margin: 2px;' color='primary' @click='descargarNom151'>Descargar Constancia</v-btn>
              </template>
            </slotbar>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color='primary' text @click='dialog = false'>Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import slotbar from '@/components/custom/slotbar.vue';
  import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';

  export default {
    components: {
      slotbar,
    },
    props: {
      doc: Array,
      disabled: Boolean,
    },
    data() {
      return {
        dialog: false,
        headers: [
          { text: 'Id', value: 'id' },
          { text: 'Título', value: 'document.title' },
          { text: 'Cliente', value: 'cliente.nombre' },
        ],
        constancias: [],
        selected: [],
        options: {
          sortBy: [],
          itemsPerPage: 5,
        },
        total: 0,
        firstLoad: true,
        mode: 'byDoc',
      }
    },
    computed: {
      noDataText() {
        let str = 'No hay constancias NOM 151';
        switch (this.mode) {
          case 'byDoc': return str + ' para este documento';
          case 'byClient': return str + ' para este cliente';
          default: return str;
        }
      },
      dialogTitle() {
        let str = 'Constancias NOM 151';
        switch (this.mode) {
          case 'byDoc':
          str += ' en el contrato';
          if (this.doc.length > 0 && typeof this.doc[0].title === 'string') return `${str} "${this.doc[0].title}"`;
          else return str;

          case 'byClient':
          str += ' del cliente';
          return str;

          default: return str;
        }
      },
      modeBtnText() {
        let str = 'Ver constancias del';
        switch (this.mode) {
          case 'byDoc': return str + ' cliente';
          case 'byClient': return str + ' contrato';
          default: return 'Error';
        }
      },
    },
    methods: {
      async getListaConstancias() {
        const defaultToastMessage = 'Error al obtener la lista de constancias.';
        const defaultConsoleMessage = 'getListaConstancias error';
        try {
          const clienteId = this.$store.getters.getClient;
          const docId = (this.mode === 'byDoc' ? this.doc[0].id : null);
          const methodName = (this.mode === 'byDoc' ? 'listNom151ByDoc' : 'listNom151');
          const options = this.options;
          const result = await this.$store.dispatch(methodName, {clienteId, docId, options});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
          this.total = result.totalElements;
          this.constancias = result.content;
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      async descargarNom151() {
        if (this.selected.length === 0) return;
        const defaultToastMessage = 'Error al descargar la constancia NOM 151.';
        const defaultConsoleMessage = 'descargarNom151 error';
        try {
          const clienteId = this.selected[0].cliente.id;
          const docId = this.selected[0].document.id;
          const nomId = this.selected[0].id;
          const result = await this.$store.dispatch('downloadNom151', {clienteId, docId, nomId});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
          const downloadUrl = URL.createObjectURL(result.data);
          const filename = this.getPropertyFromString(result.headers['content-disposition'], 'filename');
          this.downloadFromTempUrl(downloadUrl, filename);
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      getPropertyFromString(str, propName) {
        var match = str.match(new RegExp('(^| )' + propName + '=([^;]+)'));
        if (match) return match[2].replace(/['"]/g, '');
        else return '';
      },
      downloadFromTempUrl(url, filename) {
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      changeMode() {
        switch (this.mode) {
          case 'byDoc':
          this.mode = 'byClient';
          break;

          case 'byClient':
          this.mode = 'byDoc';
          break;

          default:
          console.error('changeMode error: unknown mode %s', this.mode);
          return;
        }
        this.getListaConstancias();
      },
      rowSelected(obj) {
        if (this.selected.length > 0) {
          const sel = this.selected[0];
          this.selected = [];
          if (sel.id !== obj.id) this.selected.push(obj);
        } else this.selected.push(obj);
      },
    },
    watch: {
      dialog() {
        if (this.dialog) {
          if (this.doc.length === 0) this.mode = 'byClient';
          else this.mode = 'byDoc';
          if (this.firstLoad) this.firstLoad = false;
          else this.getListaConstancias();
        } else {
          this.selected = [];
        }
      },
      options() {
        this.getListaConstancias();
      }
    },
  };
</script>

<style>
</style>
